// extracted by mini-css-extract-plugin
export default {"input":"InputMask_input__ffVtw","bigger":"InputMask_bigger__mh+qS"};